const umlConst = {
    ANCHOR_EDGE_MARGIN: 8, // px distance from a shape's corner, so an anchor point never lands exactly on the corner
    CLASS_COLLAPSED_HEADER_HEIGHT: 34, // fixed estimate for a collapsed UmlClassShape's header row, not pixel-perfect for classes without a stereotype line
    PACKAGE_COLLAPSED_HEADER_HEIGHT: 40, // matches the package title-bar space reserved elsewhere (see Core/Import/CsImportPackagePlacement.js PACKAGE_HEADER)
    SNAP_GRID_SIZE: 20, // fallback grid size for CanvasGeometry.snapToGrid — real value comes from userSettingsEngine.resolve('umlWorkspace.gridSize')
    CONNECTOR_STYLES: {
        association: { dash: false, arrowHead: 'open', color: '#8fa3c0', strokeWidth: 1.5 },
        inheritance: { dash: false, arrowHead: 'triangle', color: '#8fa3c0', strokeWidth: 1.5 },
        dependency: { dash: true, arrowHead: 'open', color: '#8fa3c0', strokeWidth: 1.5 },
    },

    PKG_VIEW_W: 400,
    PKG_VIEW_H: 460,
    PKG_VIEW_P: 10,

    PKG_PREVIEW: () => {
        return {
            w: umlConst.PKG_VIEW_W,
            h: umlConst.PKG_VIEW_H,
            p: umlConst.PKG_VIEW_P,
        };
    },
};

export default umlConst;
